export default __webpack_public_path__ + "locales/es/Notifications.json?hash=c7d873ce29b19447b73b6fe5c74827c4";